<div class="label-text">
  <div class="label">{{ label }}</div>
  <div class="text">{{ text }}</div>
</div>
